module.exports = __webpack_public_path__ + "static/media/wheel_allocation.4274bd52.png";